import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppShell } from "@/components/AppShell";
import { useTheme } from "@/components/ThemeToggle";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Pricing from "@/pages/Pricing";
import FAQ from "@/pages/FAQ";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import Onboarding from "@/pages/Onboarding";
import Assessment from "@/pages/Assessment";
import Dashboard from "@/pages/Dashboard";
import Roadmap from "@/pages/Roadmap";
import Learn from "@/pages/Learn";
import LessonView from "@/pages/LessonView";
import Practice from "@/pages/Practice";
import { Labs, LabDetail } from "@/pages/Labs";
import Projects from "@/pages/Projects";
import Interview from "@/pages/Interview";
import { PaymentCancel, PaymentSuccess } from "@/pages/Payment";
import Reports from "@/pages/Reports";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";

const Shell = ({ children, adminOnly = false }) => (
  <ProtectedRoute adminOnly={adminOnly}>
    <AppShell>{children}</AppShell>
  </ProtectedRoute>
);

function App() {
  useTheme();
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
          <Route path="/assessment" element={<ProtectedRoute><Assessment /></ProtectedRoute>} />

          <Route path="/dashboard" element={<Shell><Dashboard /></Shell>} />
          <Route path="/roadmap" element={<Shell><Roadmap /></Shell>} />
          <Route path="/learn" element={<Shell><Learn /></Shell>} />
          <Route path="/learn/:slug" element={<Shell><LessonView /></Shell>} />
          <Route path="/practice" element={<Shell><Practice /></Shell>} />
          <Route path="/labs" element={<Shell><Labs /></Shell>} />
          <Route path="/labs/:slug" element={<Shell><LabDetail /></Shell>} />
          <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/projects" element={<Shell><Projects /></Shell>} />
          <Route path="/interview" element={<Shell><Interview /></Shell>} />
          <Route path="/reports" element={<Shell><Reports /></Shell>} />
          <Route path="/profile" element={<Shell><Profile /></Shell>} />
          <Route path="/admin" element={<Shell adminOnly><Admin /></Shell>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
